import React, { useEffect, useState } from "react";
import QuickpayLanding from "./e_quick-pay-landing";
import { Hidden, Card, CardContent, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { routePaths } from "../../config/route-paths";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { pathActions } from "../../../actions/path.actions";
import EFooterSection from "../../e_home-page/e_footer-section/e_footer-section";

const useStyles = makeStyles((theme) => ({
  contentBg: {
    background: theme?.palette?.eWhite?.base + " !important",
    paddingBottom:"1% !important",
  },
  cardStyle:{
    height:"96vh"
  },
  "@global": {
    html: {
      height: "100%",
    },
    body: {
      height: "100%",
      backgroundColor: theme?.palette?.eFaint?.base,
      backgroundImage: "none !important",
    },
  },
  footerStyle: {
    bottom: 0,
    alignContent: "center",
    width: "100%",
    [theme.breakpoints.up("xl")]: {
      position: "fixed",
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "2%",
    },
  },
}));

export default function E_QuickPay() {
  const classes = useStyles();
  const [quickPayWidget, setQuickPayWidget] = useState();
  let dispatch = useDispatch();
  let widgets = useSelector((state) => state?.parametersWidgets?.WidgetLookUp);
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  useEffect(() => {
    dispatch(pathActions.getLocationPath(routePaths.QUICK_PAY));
  }, []);

  useEffect(() => {
    widgets &&
      widgets.map(
        (item) => item.widgetCode === "E_QUICKPAY" && setQuickPayWidget(item)
      );
  }, [widgets]);

  useEffect(() => {
    window.RocketChat(function () {
      this.hideWidget();
    });
  });
  return (
    <>
      {quickPayWidget?.widgetDefaultValue && (
        <>
          <Card 
           className={classes.cardStyle}
           style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
          >
            <CardContent className={classes.contentBg}>
              <QuickpayLanding />
            </CardContent>
          </Card>
          <div className={classes.footerStyle}>
            <EFooterSection />
          </div>
        </>
      )}
    </>
  );
}
